import { getAppData } from "app/getAppData";
import { setPuzzelRuntimeConfig } from "app/PuzzelAuth/puzzelAuthConfig";
import { Amplify } from "aws-amplify";

let isConfigured = false;

export const configureAuth = async (): Promise<void> => {
  if (isConfigured) {
    return;
  }

  const { authUrl, clientId, userPoolId, puzzelClientId, puzzelIdpScheme } =
    await getAppData();

  setPuzzelRuntimeConfig({
    clientId: puzzelClientId,
    idpScheme: puzzelIdpScheme,
  });

  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            redirectSignIn: [`${window.location.origin}/login-redirect`],
            redirectSignOut: [`${window.location.origin}`],
            // Domain is set in terraform with https:// at the beginning, must be removed here to avoid double https in the URL
            domain: authUrl.replace("https://", ""),
            scopes: [],
            responseType: "code",
          },
        },
        userPoolId,
        userPoolClientId: clientId,
      },
    },
  });

  isConfigured = true;
};
